module.exports = __webpack_public_path__ + "static/media/mapNode4.35fb4ddb.png";